import { yup } from '@framework/validation';
import { Widget } from '../../schema/widgets/Widget';

export const WidgetTypeInternalMetaKey = 'widgetType@internal';

/**
 * Funzione che ritorna lo schema impostando nel meta il widgetType
 * relativo al widget in oggetto. In questo modo, è possibile sapere
 * il tipo di widget collegato ad ogni valore nel form anche attraverso
 * la `forEachSchemaNode()`.
 */
export function setWidgetTypeMeta(schema: yup.AnySchema, widget: Widget) {
  return schema.meta({
    [WidgetTypeInternalMetaKey]: widget.type,
  });
}
